export default __webpack_public_path__ + "static/media/74.8ba31dd6.png";